<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="500" scrollable>
			<v-card>
				<v-card-title class="text-h6">Form Edit Member</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-text-field outlined dense label="Email" v-model="params.email" @focus="() => error_validation.email = ''" :error-messages="error_validation.email"></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideModal">Batal</v-btn>
					<v-btn color="primary" depressed class="text-capitalize" @click="simpan">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
	data () {
		return {
			params: {
				email: '',
			},
			dialog: false,
		}
	},
	props: {
	},
	computed: {
		...mapState(['error_validation']),
	},
	methods: {
		...mapMutations(['validationError']),

		showModal() {
			this.dialog = true
		},
		hideModal() {
			this.dialog = false
		},
		defineParams(data) {
			this.validationError({})
			this.params.email = data.member_email
			this.params.network_id = data.member_network_id
		},
		simpan(){
			this.$emit('resend', this.params)
		}
	},
	watch: {
	},
	created() {
	}
}
</script>
